(() => {
  const selectors = {
    form: '.js-content-form',
    planSelector: '.js-content-form__selector',
    selectorInput: '.js-content-form__selector-input',
    inputId: '.js-content-form__selector__input-id',
    sellingPlanSelect: '.js-subscribe-selector__select',
    sellingPlanInput: '.js-subscribe-selector__select-input',
    addToCartButtonPrice: '.js-content-form__button-price',
    stampedBadge: '.stamped-badge-caption',
  };
  const sellingPlan = {
    oneTime: 'one-time',
    subscribe: 'subscribe'
  };

  const addProduct = async (items) => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({'items': items})
      });

      if (response.ok) {
        window.location.href = '/cart';
        return response;
      }
    } catch (error) {
      console.error(error);
    }
  };

 const checkPlan = async () => {
  const checkedSelectorInput = document.querySelector(`${selectors.selectorInput}:checked`);
  const selectedPlan = checkedSelectorInput.closest(selectors.planSelector);

  if (selectedPlan.dataset.plan === sellingPlan.oneTime ) {
    const inputIdArray = selectedPlan.querySelectorAll(selectors.inputId);
    const items = [];
    const inputSelected = selectedPlan.nextElementSibling.querySelector('input[name="one-time-bundle-option"]:checked');

    inputIdArray.forEach((inputId) => {
      const item = {
        id: +inputId.value,
        quantity: inputSelected ? parseInt(inputSelected.getAttribute('value')) : 1,
        properties: {
          '_bundle': true,
          '_bundle_main': true,
          '_bundle_id': selectedPlan.dataset.bundleId,
          '_bundle_image': selectedPlan.dataset.bundleImage,
          '_bundle_price': selectedPlan.dataset.bundlePrice,
          '_bundle_url': selectedPlan.dataset.bundleUrl,
          '_bundle_title': selectedPlan.dataset.bundleTitle,
          '_bundle_product_list_description': selectedPlan.dataset.bundleProductListDescription,
          '_bundle_product_list_id': selectedPlan.dataset.bundleProductListId,
          '_bundle_main_product_id': selectedPlan.dataset.bundleMainProduct
        }
      };

      // '_bundle_discount_per_product': selectedPlan.dataset.bundleDiscountPerProduct,

      items.push(item)
    });

    addProduct(items);
  } else if (selectedPlan.dataset.plan === sellingPlan.subscribe) {
    const inputId = selectedPlan.querySelector(selectors.inputId);
    const sellingPlanSelect = selectedPlan.nextElementSibling.querySelector(selectors.sellingPlanSelect);
    const inputSelected = selectedPlan.nextElementSibling.querySelector('input[name="subscribe-bundle-option"]:checked');
    const items = [];
    const item = {
      id: +inputId.value,
      quantity: inputSelected ? parseInt(inputSelected.getAttribute('value')) : 1,
      selling_plan: sellingPlanSelect.value,
      properties: {
        '_bundle': true,
        '_bundle_main': true
      }
    };

    items.push(item);
    addProduct(items);
  }
 };

 const changeSellginPlan = (sellingPlanSelect) => {
  const selectedPlanInput = document.querySelector(selectors.sellingPlanInput);

  if (selectedPlanInput) {
    selectedPlanInput.value = sellingPlanSelect.value
  }
 };

 const changePlanSelector = (event) => {
  const currentSelectorInput = event.currentTarget;
  const currentPlan = currentSelectorInput.closest(selectors.planSelector)
  if(currentPlan.classList.contains('subsribe-selector')) {
    const inputChecked = document.querySelector('.subscribe-selector__bundles input[name="subscribe-bundle-option"]:checked')
    inputChecked?.dispatchEvent(new Event('change'))
    return
  } 
  const inputChecked = document.querySelector('.one-time-selector__bundles input[name="one-time-bundle-option"]:checked')
  inputChecked?.dispatchEvent(new Event('change'))
 };

 const changeStamped = () => {
  const stampedBadge = document.querySelector(selectors.stampedBadge);

  if (stampedBadge) {
    clearInterval(stampedIntervalId);

    const content = `${stampedBadge.dataset.rating}/5 • `

    stampedBadge.insertAdjacentText('afterbegin', content);
  };
 };

 const changeButtonPrice = (input) => {
  const addToCartButtonPrice = document.querySelectorAll(selectors.addToCartButtonPrice);
  if(addToCartButtonPrice && input.dataset.productMoney != '') {
    addToCartButtonPrice.forEach(button => {
      button.innerHTML = input.dataset.productMoney;
    });
  }

  const checkedSelectorInput = document.querySelector(`${selectors.selectorInput}:checked`);
  const selectedPlan = checkedSelectorInput.closest(selectors.planSelector);
  // Get the price elements from the selected plan
  const price = selectedPlan.querySelector('.one-time-selector__label-title-price:not(.one-time-selector__label-title-price--old)');
  const priceOld = selectedPlan.querySelector('.one-time-selector__label-title-price.one-time-selector__label-title-price--old');
  const priceSubscribe = selectedPlan.querySelector('.subscribe-selector__label-header-title-price:not(.subscribe-selector__label-header-title-price--old)');
  const priceSubscribeOld = selectedPlan.querySelector('.subscribe-selector__label-header-title-price.subscribe-selector__label-header-title-price--old');

  if (price && priceOld) {
    price.innerHTML = input.dataset.productMoney != '' ? input.dataset.productMoney : '';
    priceOld.innerHTML = input.dataset.productOldMoney != '' ? input.dataset.productOldMoney : '';
  }
  if (priceSubscribe && priceSubscribeOld) {
    priceSubscribe.innerHTML = input.dataset.productMoney != '' ? input.dataset.productMoney : '';
    priceSubscribeOld.innerHTML = input.dataset.productOldMoney != '' ? input.dataset.productOldMoney : '';
  }
 };

 const setSelectedInput = () => {
  const oneTimeInput = document.querySelector('input[type="radio"].one-time-selector__input')
  const inputOneTimeChecked = document.querySelector('.one-time-selector__bundles input[name="one-time-bundle-option"]:checked')
  
  const inputSubscribeChecked = document.querySelector('.subscribe-selector__bundles input[name="subscribe-bundle-option"]:checked')
  if(oneTimeInput.checked) {
    inputOneTimeChecked?.dispatchEvent(new Event('change'))
    return
  }
  inputSubscribeChecked?.dispatchEvent(new Event('change'))
 }

 const initListiner = () => {
  const form = document.querySelector(selectors.form);
  const sellingPlanSelect = document.querySelector(selectors.sellingPlanSelect);
  const selectorInputArray = document.querySelectorAll(selectors.selectorInput);
  const subscribeInputs = document.querySelectorAll('.subscribe-selector__bundles input[name="subscribe-bundle-option"]');
  const oneTimeInputs = document.querySelectorAll('.one-time-selector__bundles input[name="one-time-bundle-option"]');

  form?.addEventListener('submit', (e) => {
    e.preventDefault();
    checkPlan();
  });

  sellingPlanSelect?.addEventListener('change', () => {changeSellginPlan(sellingPlanSelect)});
  selectorInputArray.forEach((selectorInput) => {
    selectorInput.addEventListener('change', changePlanSelector);
  });

  subscribeInputs?.forEach((input) => input.addEventListener('change', () => changeButtonPrice(input)));
  oneTimeInputs?.forEach((input) => input.addEventListener('change', () => changeButtonPrice(input)));

  window.setSelectedInput = setSelectedInput;
 };

 const stampedIntervalId = setInterval(changeStamped, 1000);

 initListiner();
})();

window.addEventListener('load', function() {
  setSelectedInput();
});